
import { useState, useEffect } from 'react';
import AnimatedSection from '../../components/base/AnimatedSection';

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('الكل');
  const [newsletterUrl, setNewsletterUrl] = useState('');

  useEffect(() => {
    document.title = 'المدونة | شركة الإعلام المتقدم - مقالات ونصائح في الإعلام والتسويق';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'اقرأ أحدث المقالات والنصائح في مجال الإعلام الرقمي والتسويق الإبداعي، تحليلات السوق، واتجاهات التكنولوجيا من خبراء شركة الإعلام المتقدم');
    }

    // Set newsletter form URL (will be replaced with actual URL from get_form_url)
    setNewsletterUrl('https://example.com/newsletter-subscription');
  }, []);

  const categories = ['الكل', 'التسويق الرقمي', 'الإعلام', 'التكنولوجيا', 'ريادة الأعمال', 'التصميم'];

  const featuredPosts = [
    {
      id: 1,
      title: 'مستقبل التسويق الرقمي في عام 2024',
      excerpt: 'استكشف أحدث الاتجاهات والتقنيات التي ستشكل مستقبل التسويق الرقمي والإعلان الإلكتروني',
      category: 'التسويق الرقمي',
      author: 'أحمد محمد',
      date: '15 يناير 2024',
      readTime: '8 دقائق',
      image: 'https://public.readdy.ai/ai/img_res/cfc820401d4f438e4de7d86c4b080bc9.jpg',
      featured: true
    },
    {
      id: 2,
      title: 'كيفية بناء هوية بصرية قوية لعلامتك التجارية',
      excerpt: 'دليل شامل لإنشاء هوية بصرية متميزة تعكس قيم علامتك التجارية وتجذب جمهورك المستهدف',
      category: 'التصميم',
      author: 'سارة أحمد',
      date: '12 يناير 2024',
      readTime: '6 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Brand%20identity%20design%20process%2C%20creative%20visual%20branding%20elements%2C%20logo%20design%20workspace%2C%20color%20palette%20selection%2C%20typography%20samples%2C%20professional%20graphic%20design%20studio%2C%20modern%20creative%20environment&width=800&height=500&seq=blog-featured-2&orientation=landscape',
      featured: true
    },
    {
      id: 3,
      title: 'الذكاء الاصطناعي في صناعة المحتوى الإعلامي',
      excerpt: 'تعرف على كيفية استخدام تقنيات الذكاء الاصطناعي لتطوير وإنتاج محتوى إعلامي أكثر فعالية',
      category: 'التكنولوجيا',
      author: 'محمد علي',
      date: '10 يناير 2024',
      readTime: '10 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20in%20media%20content%20creation%2C%20AI%20technology%20interface%2C%20automated%20content%20generation%2C%20machine%20learning%20algorithms%2C%20futuristic%20digital%20workspace%2C%20high-tech%20environment%2C%20blue%20and%20white%20colors&width=800&height=500&seq=blog-featured-3&orientation=landscape',
      featured: true
    }
  ];

  const blogPosts = [
    {
      id: 4,
      title: 'استراتيجيات التسويق عبر وسائل التواصل الاجتماعي',
      excerpt: 'نصائح عملية لتطوير استراتيجية تسويق فعالة عبر منصات التواصل الاجتماعي المختلفة',
      category: 'التسويق الرقمي',
      author: 'فاطمة حسن',
      date: '8 يناير 2024',
      readTime: '7 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20marketing%20strategy%2C%20multiple%20social%20platforms%20interface%2C%20engagement%20analytics%2C%20content%20calendar%20planning%2C%20digital%20marketing%20workspace%2C%20modern%20office%20environment&width=600&height=400&seq=blog-post-1&orientation=landscape'
    },
    {
      id: 5,
      title: 'أهمية تحسين محركات البحث SEO للشركات الناشئة',
      excerpt: 'كيف يمكن للشركات الناشئة الاستفادة من تحسين محركات البحث لزيادة الوصول والمبيعات',
      category: 'التسويق الرقمي',
      author: 'عمر خالد',
      date: '5 يناير 2024',
      readTime: '9 دقائق',
      image: 'https://readdy.ai/api/search-image?query=SEO%20optimization%20for%20startups%2C%20search%20engine%20results%20page%2C%20keyword%20research%20tools%2C%20website%20analytics%20dashboard%2C%20digital%20marketing%20metrics%2C%20professional%20business%20setting&width=600&height=400&seq=blog-post-2&orientation=landscape'
    },
    {
      id: 6,
      title: 'تطوير المحتوى الإعلامي الرقمي المؤثر',
      excerpt: 'استراتيجيات إنتاج محتوى رقمي جذاب ومؤثر يحقق أهداف التواصل مع الجمهور',
      category: 'الإعلام',
      author: 'ليلى محمود',
      date: '3 يناير 2024',
      readTime: '6 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Digital%20media%20content%20creation%2C%20video%20production%20studio%2C%20content%20creator%20workspace%2C%20multimedia%20editing%2C%20storytelling%20elements%2C%20creative%20media%20environment&width=600&height=400&seq=blog-post-3&orientation=landscape'
    },
    {
      id: 7,
      title: 'الابتكار في تقنيات الإنتاج الإعلامي',
      excerpt: 'أحدث التقنيات والأدوات المستخدمة في إنتاج المحتوى الإعلامي عالي الجودة',
      category: 'التكنولوجيا',
      author: 'يوسف أحمد',
      date: '1 يناير 2024',
      readTime: '8 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Innovative%20media%20production%20technology%2C%20professional%20video%20equipment%2C%20broadcasting%20studio%2C%20high-tech%20cameras%20and%20lighting%2C%20modern%20media%20production%20facility&width=600&height=400&seq=blog-post-4&orientation=landscape'
    },
    {
      id: 8,
      title: 'بناء فريق عمل إبداعي في مجال الإعلام',
      excerpt: 'كيفية اختيار وتطوير فريق عمل متخصص في الإنتاج الإعلامي والتسويق الإبداعي',
      category: 'ريادة الأعمال',
      author: 'نور الدين',
      date: '28 ديسمبر 2023',
      readTime: '7 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Creative%20media%20team%20collaboration%2C%20diverse%20professionals%20working%20together%2C%20brainstorming%20session%2C%20modern%20office%20space%2C%20teamwork%20in%20creative%20industry&width=600&height=400&seq=blog-post-5&orientation=landscape'
    },
    {
      id: 9,
      title: 'تحليل البيانات في الحملات الإعلانية',
      excerpt: 'استخدام تحليل البيانات لتحسين أداء الحملات الإعلانية وزيادة العائد على الاستثمار',
      category: 'التسويق الرقمي',
      author: 'رانيا سالم',
      date: '25 ديسمبر 2023',
      readTime: '9 دقائق',
      image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20for%20advertising%20campaigns%2C%20marketing%20dashboard%20with%20charts%20and%20graphs%2C%20performance%20metrics%20visualization%2C%20business%20intelligence%20tools&width=600&height=400&seq=blog-post-6&orientation=landscape'
    }
  ];

  const filteredPosts = selectedCategory === 'الكل' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;

    if (!email) {
      alert('يرجى إدخال البريد الإلكتروني');
      return;
    }

    // Simulate form submission
    alert('تم الاشتراك بنجاح! شكراً لك');
    (e.target as HTMLFormElement).reset();
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20digital%20blog%20and%20content%20creation%20concept%2C%20professional%20writing%20workspace%2C%20laptop%20with%20articles%2C%20creative%20content%20development%2C%20clean%20minimalist%20office%20environment%2C%20blue%20and%20purple%20gradient%20background&width=1920&height=800&seq=blog-hero&orientation=landscape')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-900/80 to-purple-900/80" />
        
        <div className="container mx-auto px-4 relative z-10">
          <AnimatedSection animation="fadeIn" className="text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
              مدونة الإعلام المتقدم
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
              اكتشف أحدث الاتجاهات والنصائح في عالم الإعلام الرقمي والتسويق الإبداعي
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Featured Posts */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">المقالات المميزة</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              أحدث وأهم المقالات في مجال الإعلام والتسويق الرقمي
            </p>
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {featuredPosts.map((post, index) => (
              <AnimatedSection 
                key={post.id}
                animation="scaleUp"
                delay={index * 200}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center gap-4">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {post.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {post.readTime}
                      </span>
                    </div>
                    <span>{post.date}</span>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts with Filter */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">جميع المقالات</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              تصفح مكتبتنا الشاملة من المقالات والنصائح المتخصصة
            </p>

            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                    selectedCategory === category
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-white text-gray-600 hover:bg-blue-50 hover:text-blue-600 shadow-md'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post, index) => (
              <AnimatedSection 
                key={post.id}
                animation="slideUp"
                delay={index * 100}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-user-line"></i>
                        {post.author}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {post.readTime}
                      </span>
                    </div>
                    <span>{post.date}</span>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-purple-900">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              اشترك في نشرتنا البريدية
            </h2>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8 leading-relaxed">
              احصل على أحدث المقالات والنصائح المتخصصة في مجال الإعلام والتسويق مباشرة في بريدك الإلكتروني
            </p>
            
            <form 
              onSubmit={handleNewsletterSubmit}
              className="max-w-md mx-auto"
              data-readdy-form
              id="newsletter-form"
            >
              <div className="flex flex-col sm:flex-row gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="أدخل بريدك الإلكتروني"
                  required
                  className="flex-1 px-6 py-4 rounded-xl border-0 text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-white focus:outline-none text-sm"
                />
                <button
                  type="submit"
                  className="px-8 py-4 bg-white text-blue-900 font-semibold rounded-xl hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap"
                >
                  <i className="ri-mail-send-line ml-2"></i>
                  اشترك الآن
                </button>
              </div>
            </form>
          </AnimatedSection>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
